/* eslint-disable react-hooks/exhaustive-deps */
import {createContext, FC, useContext, useEffect, useMemo, useState} from 'react'
import {WithChildren} from '../../../../../_dashboard/helpers'
import {useQueryRequest} from './QueryRequestProvider'

type MailOrdersListFiltersContextValue = {
  searchInput: string
  setSearchInput: (value: string) => void
  statusFilter: string
  setStatusFilter: (value: string) => void
  createdFromFilter: string
  setCreatedFromFilter: (value: string) => void
  createdToFilter: string
  setCreatedToFilter: (value: string) => void
}

const MailOrdersListFiltersContext = createContext<MailOrdersListFiltersContextValue | undefined>(
  undefined
)

const MailOrdersListFiltersProvider: FC<WithChildren> = ({children}) => {
  const {updateState} = useQueryRequest()
  const [searchInput, setSearchInput] = useState('')
  const [statusFilter, setStatusFilter] = useState('')
  const [createdFromFilter, setCreatedFromFilter] = useState('')
  const [createdToFilter, setCreatedToFilter] = useState('')

  const activeSearch = useMemo(() => searchInput.trim(), [searchInput])

  useEffect(() => {
    updateState({
      page: 0,
      search: activeSearch || undefined,
      status: statusFilter || undefined,
      createdFrom: createdFromFilter || undefined,
      createdTo: createdToFilter || undefined,
    })
  }, [activeSearch, statusFilter, createdFromFilter, createdToFilter, updateState])

  const value = useMemo(
    () => ({
      searchInput,
      setSearchInput,
      statusFilter,
      setStatusFilter,
      createdFromFilter,
      setCreatedFromFilter,
      createdToFilter,
      setCreatedToFilter,
    }),
    [searchInput, statusFilter, createdFromFilter, createdToFilter]
  )

  return (
    <MailOrdersListFiltersContext.Provider value={value}>
      {children}
    </MailOrdersListFiltersContext.Provider>
  )
}

const useMailOrdersListFilters = (): MailOrdersListFiltersContextValue => {
  const context = useContext(MailOrdersListFiltersContext)
  if (!context) {
    throw new Error('useMailOrdersListFilters must be used within MailOrdersListFiltersProvider')
  }
  return context
}

export {MailOrdersListFiltersProvider, useMailOrdersListFilters}
